/**
 * KAN-718: свой почтовый ящик организации.
 *
 *   GET    /api/v1/email-mailbox/            - текущие настройки (или общий ящик платформы)
 *   PUT    /api/v1/email-mailbox/            - сохранить; пустой пароль оставляет старый
 *   DELETE /api/v1/email-mailbox/            - вернуться на общий ящик
 *   POST   /api/v1/email-mailbox/check/      - проверка полей формы (пустое тело: сохранённых)
 *   POST   /api/v1/email-mailbox/test-send/  - тестовое письмо {to}
 */
import apiClient from './client';
import type {
  Mailbox,
  MailboxBody,
  MailboxCheckResult,
  MailboxTestSendResult,
} from '@/types/emailMailbox';

const BASE = '/api/v1/email-mailbox/';

export const emailMailboxApi = {
  get: async (): Promise<Mailbox> => (await apiClient.get(BASE)).data,
  save: async (data: MailboxBody): Promise<Mailbox> => (await apiClient.put(BASE, data)).data,
  reset: async (): Promise<void> => {
    await apiClient.delete(BASE);
  },
  check: async (data?: MailboxBody): Promise<MailboxCheckResult> =>
    (await apiClient.post(`${BASE}check/`, data ?? {})).data,
  testSend: async (to: string): Promise<MailboxTestSendResult> =>
    (await apiClient.post(`${BASE}test-send/`, { to })).data,
};
